import { memo } from 'react';

import { type SearchBoardsResponse } from '@air/api/types';

import { SearchCommandBoardListItem } from '~/components/SearchCommand/SearchCommandBoardListItem';
import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';

export type SearchCommandBoardListProps = {
  boards: SearchBoardsResponse[];
  onBoardClick: (board: SearchBoardsResponse) => void;
};

export const SearchCommandBoardList = memo(({ boards, onBoardClick }: SearchCommandBoardListProps) => {
  return (
    <SearchCommandGroup heading="Jump to">
      {boards.map((board) => (
        <SearchCommandBoardListItem board={board} key={board.id} onSelect={onBoardClick} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandBoardList.displayName = 'SearchCommandBoardList';
